module.exports = __webpack_public_path__ + "static/media/img2-4.794a57fb.png";